import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from '@/components/feedback';

import { AppRouter } from './AppRouter';

/**
 * Application root. Providers (router, theme, query client, i18n…) are
 * composed here so `main.tsx` stays a three-line bootstrap.
 */
export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
